import * as i18next from "i18next";

const data = require("./dk.json");

i18next.init({
  resources: {
    dk: {
      translations: (window as any).i18nData || data,
    },
  },
  fallbackLng: "dk",
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys
  nsSeparator: "¤",
  interpolation: {
    formatSeparator: ",",
    escapeValue: false,
  },
  react: {
    useSuspense: false, // Updated from wait to useSuspense for better compatibility with recent versions
  },
});

export default i18next;
